module.exports = __webpack_public_path__ + "img/toddl.co_logo white.02979234.svg";